module.exports = __webpack_public_path__ + "img/footer_bg.0fe368e3.png";